import React, { useState } from 'react'
import './Headlock.css'
import { Link } from 'react-router-dom'

export default function Stable() {
    const [stableModal, toggleStableModal] = useState(false)
    //<div onClick={() => toggleStableModal(true)} className="stableButton__container"> //TO OPEN Stable MODAL
    return (
        <div className="headlockButton">
            <Link to={{ pathname: '/headlock' }}>
                <div className="headlockButton__container">Headlock</div>
            </Link>
        </div>
    )
}
